import { ICON_NAMES } from "../lib/icons";

const ACCENTS = ["blue", "orange", "green"];

export const RESOURCE_CONFIG = {
  services: {
    label: "Servicios",
    singular: "Servicio",
    titleField: "name",
    fields: [
      { key: "name", label: "Nombre", type: "text", required: true },
      { key: "description", label: "Descripción", type: "textarea" },
      { key: "icon", label: "Icono", type: "select", options: ICON_NAMES, default: "ShieldCheck" },
      { key: "accent", label: "Color de acento", type: "select", options: ACCENTS, default: "blue" },
      { key: "image", label: "Imagen (opcional)", type: "image" },
      { key: "features", label: "Características", type: "list" },
      { key: "order", label: "Orden", type: "number", default: 0 },
      { key: "published", label: "Publicado", type: "boolean", default: true },
    ],
  },
  brands: {
    label: "Marcas",
    singular: "Marca",
    titleField: "name",
    fields: [
      { key: "name", label: "Nombre", type: "text", required: true },
      { key: "category", label: "Categoría", type: "text" },
      { key: "logo", label: "Logo", type: "image" },
      { key: "link", label: "Enlace (opcional)", type: "text" },
      { key: "order", label: "Orden", type: "number", default: 0 },
      { key: "published", label: "Publicado", type: "boolean", default: true },
    ],
  },
  software: {
    label: "Software GLG",
    singular: "Software",
    titleField: "name",
    fields: [
      { key: "name", label: "Nombre", type: "text", required: true },
      { key: "tagline", label: "Subtítulo", type: "text" },
      { key: "icon", label: "Icono", type: "select", options: ICON_NAMES, default: "Code2" },
      { key: "accent", label: "Color de acento", type: "select", options: ACCENTS, default: "blue" },
      { key: "description", label: "Descripción", type: "textarea" },
      { key: "image", label: "Imagen / captura", type: "image" },
      { key: "features", label: "Características", type: "list" },
      { key: "link", label: "Enlace (opcional)", type: "text" },
      { key: "order", label: "Orden", type: "number", default: 0 },
      { key: "published", label: "Publicado", type: "boolean", default: true },
    ],
  },
  testimonials: {
    label: "Testimonios",
    singular: "Testimonio",
    titleField: "name",
    fields: [
      { key: "name", label: "Nombre", type: "text", required: true },
      { key: "company", label: "Empresa", type: "text" },
      { key: "testimonial", label: "Testimonio", type: "textarea" },
      { key: "image", label: "Foto (opcional)", type: "image" },
      { key: "order", label: "Orden", type: "number", default: 0 },
      { key: "published", label: "Publicado", type: "boolean", default: true },
    ],
  },
  promotions: {
    label: "Promociones",
    singular: "Promoción",
    titleField: "title",
    fields: [
      { key: "title", label: "Título", type: "text", required: true },
      { key: "description", label: "Descripción", type: "textarea" },
      { key: "image", label: "Imagen", type: "image" },
      { key: "start_date", label: "Fecha de inicio", type: "text" },
      { key: "end_date", label: "Fecha de fin", type: "text" },
      { key: "button_label", label: "Texto del botón", type: "text" },
      { key: "button_link", label: "Enlace del botón", type: "text" },
      { key: "order", label: "Orden", type: "number", default: 0 },
      { key: "published", label: "Publicado", type: "boolean", default: true },
    ],
  },
};

export const defaultsFor = (resource) => {
  const cfg = RESOURCE_CONFIG[resource];
  const obj = {};
  cfg.fields.forEach((f) => {
    if (f.type === "list" || f.type === "imagelist") obj[f.key] = [];
    else if (f.type === "boolean") obj[f.key] = f.default ?? true;
    else if (f.type === "number") obj[f.key] = f.default ?? 0;
    else obj[f.key] = f.default ?? "";
  });
  return obj;
};
